import { environments } from './env';
import { buildEnvironmentFromLocation } from '@updater-core/lib/environment/environment';

export const ENVIRONMENT = buildEnvironmentFromLocation(environments);

export const isEnv = (...envs) => envs.indexOf(ENVIRONMENT.name) !== -1;
